import React, { useEffect, useRef } from "react";
import { use, init, throttle } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { ScatterChart, LineChart, PieChart, BarChart, RadarChart } from "echarts/charts";
import { GridComponent, TooltipComponent, LegendComponent, RadarComponent } from "echarts/components";

/* ============================================================
   Talention — Módulo Igualdad · Envoltura de ECharts
   ============================================================ */

/* ECharts (registro modular para tree-shaking).
   Efecto de módulo: se ejecuta una sola vez al importar este fichero,
   nunca dentro de un efecto de componente. */
use([
  CanvasRenderer,
  ScatterChart, LineChart, PieChart, BarChart, RadarChart,
  GridComponent, TooltipComponent, LegendComponent, RadarComponent,
]);

const IgualdadChart = ({ option, style }) => {
  const rootRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    const el = rootRef.current;
    const chart = init(el);
    chartRef.current = chart;
    chart.resize();

    const { offsetWidth, offsetHeight } = el;
    let primera = true;
    const resize = throttle(() => chart.resize(), 100);
    const ro = new ResizeObserver(() => {
      if (primera) {
        primera = false;
        if (el.offsetWidth === offsetWidth && el.offsetHeight === offsetHeight) return;
      }
      resize();
    });
    ro.observe(el);

    return () => {
      ro.disconnect();
      chart.dispose();
      chartRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (!option) return;
    const chart = chartRef.current;
    if (chart) chart.setOption(option, { notMerge: true });
  }, [option]);

  return <div ref={rootRef} style={{ width: "100%", height: "100%", minWidth: 0, ...style }} />;
};

export { IgualdadChart };
